<style scoped>
.search-area-div {
  width: 100px;
  text-align: center;
}
/deep/.el-col-6 {
  display: flex;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div"><span style="color: red">*</span>公司名称</div>
          <el-select
            size="mini"
            v-model="page.tenantGuid"
            placeholder="请选择"
            :clearable="true"
            @change="changeTenant"
            filterable
            class="ipt-sty"
          >
            <el-option
              v-for="item in sendTenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">产品名称</div>
          <el-input
            v-model="page.goodsName"
            size="mini"
            class="ipt-sty"
            placeholder="请输入名称"
            :clearable="true"
          ></el-input>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">是否竞品</div>
          <el-select
            size="mini"
            v-model="page.isCompetitor"
            placeholder="请选择"
            :clearable="true"
            filterable
            class="ipt-sty"
          >
            <el-option
              v-for="item in optionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">核算单元</div>
          <el-select v-model="bizUnitNames" class="ipt-sty" multiple size="mini" placeholder="请选择">
            <el-option v-for="item in bizUnitNameOptions" :key="item.guid" :label="item.label" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">是否处方药</div>
          <el-select
            size="mini"
            v-model="page.isPrescription"
            placeholder="请选择"
            :clearable="true"
            filterable
            class="ipt-sty"
          >
            <el-option
              v-for="item in optionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button v-if="getBtnPermissionsByName('添加产品')" size="mini" type="info" @click="addProduct">
        添加产品
      </el-button>
      <!-- <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
      <el-button v-if="getBtnPermissionsByName('导出产品资料')" size="mini" type="info" @click="exportProduct()">
        导出产品资料
      </el-button>
      <el-button v-if="getBtnPermissionsByName('批量导入产品')" size="mini" type="info" @click="batchImport()">
        批量导入产品
        </el-button >
      <!-- <el-button v-if="getBtnPermissionsByName('批量导入医院价格')" size="mini" type="info" @click="openSubmitAlert(1)">
        批量导入医院价格
      </el-button> -->
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        :data="productInformationList"
        :height="tableHeight"
        ref="tableRef"
        style="width: 100%"
        stripe
        border
        row-key="guid"
        tooltip-effect="light"
      >
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="企业名称"
          min-width="180"
          header-align="center"
          align="left"
          show-overflow-tooltip
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="goodsName"
          label="产品名称"
          min-width="180"
          header-align="center"
          align="left"
          fixed="left"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="goodsCode" label="产品编码" header-align="center" align="left"></el-table-column>
        <el-table-column
          prop="goodsSpec"
          label="规格"
          header-align="center"
          align="left"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="unitStyle"
          label="单位"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="60"
        ></el-table-column>
        <el-table-column
          prop="producer"
          label="生产企业"
          min-width="180"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        
        <el-table-column prop="price" label="单价" header-align="center" align="right" width="110">
          <template slot-scope="scope">
            <span v-show="scope.row.priceType == '1'">{{ scope.row.price | numDigit | numFmt }}</span>
            <span v-show="scope.row.priceType == '2'"
              >{{ scope.row.price | numDigit | numFmt }}~{{ scope.row.maxPrice | numDigit | numFmt }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="isPrescription" label="是否处方药" width="90" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.isPrescription == 'Y' ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="isCompetitor" label="是否竞品" width="90" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.isCompetitor == 'Y' ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="isMain" label="是否主品" width="90" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.isCompetitor === 'Y' ? '-' : scope.row.isMain === 'Y' ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="isMain" label="主要竞品" width="90" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.isCompetitor === 'Y' ? scope.row.isMain === 'Y' ? '是' : '否' : '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bizUnitGuid"
          label="核算单元"
          width="90"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ unitIdToName(scope.row.bizUnitName) }}
          </template>
        </el-table-column>
        <!-- 商品大类 -->
        <el-table-column
          prop="goodsClassNames"
          label="产品大类"
          width="140"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ Array.isArray(scope.row.goodsClassNames) ? scope.row.goodsClassNames.join('、') : '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="treatDiseasesKind"
          label="主治病种"
          width="140"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.treatDiseasesKind }}
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsBenchmarkName"
          label="对标自家产品"
          width="140"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.goodsBenchmarkName }}
          </template>
        </el-table-column>
        <el-table-column prop="bigUnitQty" label="装箱量" min-width="100" sortable header-align="center" align="right">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人" min-width="100"  header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" min-width="100"  header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="140" fixed="right">
          <template slot-scope="scope">
            <a v-if="getBtnPermissionsByName('编辑')" class="txt-color" @click="editProduct(scope.row,scope.$index)">编辑 </a>
            <a v-if="getBtnPermissionsByName('详情')" class="txt-color" @click="lookProduct(scope.row,scope.$index)">详情 </a>
            <!-- <a v-if="getBtnPermissionsByName('区域指导价')" class="txt-color" @click="toLink(scope.row.guid)"
              >区域指导价
            </a> -->
            <!-- <a
              class="txt-color"
              v-if="scope.row.isPrescription == 'Y' && getBtnPermissionsByName('医院指导价')"
              @click="toLinkHospital(scope.row.guid)"
              >医院指导价
            </a> -->
            <a v-if="getBtnPermissionsByName('删除')" class="txt-color-red" @click="getDelete(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
    <!-- 批量导入产品 -->
    <el-dialog :title="dialogFormVisibleIITitle" :visible.sync="dialogFormVisibleII" width="700px" height="900px">
      <el-steps :active="active" align-center>
        <el-step title="上传文件"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div v-if="active == 1">
        <h3>导入成功，请核对！</h3>
        <p>{{ msg }}</p>
        <span v-if="showBtn" style="text-decoration: underline; cursor: pointer" @click="downLoadErrorExcel"
          >下载导入失败数据</span
        >
      </div>
      <div class="search-area" style="margin-top: -15px; margin-left: 20px">
        <div class="import-sty">
          <div v-if="active == 0">
            <div class="ml71">
              <div class="mt15 mt50">
                下载模板：<el-button plain size="medium" @click="downLoadExcel">下载文件模板</el-button>
              </div>
              <div
                slot="tip"
                class="el-upload__tip"
                style="text-indent: 70px; margin-bottom: 50px; color: #888; line-height: 20px"
              >
                <div>注意事项：</div>
                <div>1、请先下载Excel模版，严格按照模板内容填入数据，再上传文件到系统;</div>
                <div>2、若导入产品已存在，那么原价格将覆盖；</div>
              </div>
              <div class="mt15 mt15 h120">
                <p class="fl">导入文件：</p>
                <el-upload
                  class="upload-demo fl"
                  action="#"
                  :before-upload="beforeUpload"
                  multiple
                  :limit="1"
                  accept=".xlsx,.xsl,.xls,.xlsm"
                  :auto-upload="false"
                  :on-change="changeFile"
                  :on-exceed="handleExceed"
                  ref="upload"
                >
                  <el-button size="medium" type="info">点击上传文件</el-button>
                  <div slot="tip" class="el-upload__tip" style="color: #888; line-height: 20px">
                    注意事项：<br />
                    1、仅支持excel文件，大小 &lt;= 2M；<br />
                    2、使用 Office 2010 及以上版本，避免出现乱码；<br />
                  </div>
                </el-upload>
              </div>
              <div slot="footer" class="dialog-footer" style="width: 60%; text-align: right">
                <el-button plain size="medium" @click="closeUpload">取消</el-button>
                <el-button size="medium" type="info" @click="sureLoad">确定</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="进度提示" :visible.sync="dialogVisible" width="30%">
      <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import btnPermisson from '@/views/mixins/btnPermisson';
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  name:'productInformation',
  mixins: [btnPermisson],
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo:userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 195,
      productInformationList: [],
      sendTenantList:[],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        goodsCode: '',
        goodsName: '',
        isCompetitor:'',
        isPrescription:'',
      },
      optionList:[
        {
          label:'是',
          value:'Y'
        },
        {
          label:'否',
          value:'N'
        },
      ],
      right: '',
      loading: false,
      unitsData: [],
      bizUnitNameOptions: [],
      bizUnitNames: [],
      pictContentList: [],
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      //导入
      active: 0,
      id: '',
      dialogFormVisibleII: false,
      fullscreenLoading: false,
      file: '',
      msg: '',
      showBtn: false,
      progressGuid: '',
      percentage: 0,
      dialogVisible: false,
      dialogType: '',
      dialogFormVisibleIITitle: '批量导入产品',
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 296;
        this.contentMainHeight = window.innerHeight - 230;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 195;
        return;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/addProduct') {
      next((vm) => {
        if (vm.page.tenantGuid) {
          vm.getData(false,() => {
            if (vm.$store.getters.getPageY) vm.tableScrollToRow(vm.$refs.tableRef, vm.$store.getters.getPageY); // 表格行跳转
          });
        }
        
      });
    } else {
      next();
    }
  },
  activated() {
    if (this.page.tenantGuid) {
      this.getData(false);
    }
  },
  created() {
    // 列表
    // this.getData(false);
    this.getbizUnitNameOptions();
    // 获取商品大类数据
    this.getMenuList();
    this.getTenantOperationRelList();
  },
  methods: {
    //获取公司下拉
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 新产品导入
    batchImport(guid) {
      this.$router.push({ path: '/importProductInfoList', query: { productGuid: this.$route.query.productGuid } });
    },
    unitIdToName(str) {
      if (!str) return;
      var arr = str.split(',');
      if (!arr?.length) {
        return;
      }
      let unitIdToNameStr = arr[0];
      if (arr.length == 1) {
        return unitIdToNameStr;
      }
      if (arr.length > 1) {
        return unitIdToNameStr + '等' + arr.length + '个';
      }
    },
    changeTenant(tenantGuid) {
      if (tenantGuid) this.getbizUnitNameOptions(tenantGuid);
      this.$forceUpdate();
    },
    getbizUnitNameOptions(tenantGuid) {
      let page = {
        pageIndex: 1,
        pageSize: 1000,
        tenantGuid: tenantGuid || '',
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.bizUnitNameOptions = res.data.data.records || []
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: self.page.tenantGuid,
      };
      self.bizUnitNames = [];
      self.getData(true);
    },
    getData(flg,callBack) {
      let self = this;
      if(!this.page.tenantGuid) {
        this.$message.warning('请选择所属公司')
        return;
      } 
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
        self.page.bizUnitGuid = this.bizUnitNames;
      }
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          let productInformationList = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.productInformationList = productInformationList;
          self.$nextTick(()=>{
            if (callBack) callBack()
          })
        } else {
          self.$message.error(res.msg || '服务异常');
          console.log(res);
          self.loading = false;
        }
      });
    },
    //导出产品
    exportProduct() {
      if (!this.page.tenantGuid) {
        this.$message.error('请选择公司')
        return
      }
      let self = this;
      self.fullscreenLoading = true;
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      let query = {
        // guid:'0003',
        goodsName: self.page.goodsName,
        bizUnitGuid: self.bizUnitNames,
        tenantGuid: self.page.tenantGuid,
        isCompetitor: self.page.isCompetitor,
        isPrescription: self.page.isPrescription,
      };
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/export-goods`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val
      this.getData();
    },
    addProduct() {
      this.$router.push(`/addProduct?productGuid=${this.$route.query.productGuid}`);
    },
    editProduct(row,index) {
      this.$store.commit('setPageY', index);
      this.$router.push(`/addProduct?guid=${row.guid}&productGuid=${this.$route.query.productGuid}&tenantGuid=${row.tenantGuid}`);
    },
    lookProduct(row,index) {
      this.$store.commit('setPageY', index);
      this.$router.push(`/addProduct?guid=${row.guid}&productGuid=${this.$route.query.productGuid}&operationMode=look`);
    },
    getDelete(guid) {
      let self = this;
      self.multipleSelection = [];
      self.multipleSelection.push(guid);
      self
        .$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msProductService}/goods/data/delete`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除产品成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    toLink(guid) {
      this.$router.push({
        path: '/productGuidePrice',
        query: { guid: guid, productGuid: this.$route.query.productGuid },
      });
    },
    toLinkHospital(guid) {
      this.$router.push({
        path: '/productHospitalPrice',
        query: { guid: guid, productGuid: this.$route.query.productGuid },
      });
    },
    /** 产品图片 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.pictContentList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.pictContentList.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '产品图片',
              url: res.data.data,
            };
            self.pictContentList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /** 产品图片 上传相关 结束*/
    // 导入产品开始
    openSubmitAlert(type) {
      if (type == 1) {
        this.dialogType = 'hospital';
        this.dialogFormVisibleIITitle = '批量导入医院价格';
      } else {
        this.dialogType = '';
        this.dialogFormVisibleIITitle = '批量导入产品';
      }
      this.dialogFormVisibleII = true;
      this.active = 0;
      setTimeout(() => {
        this.$refs.upload.clearFiles();
      }, 200);
    },
    downLoadExcel() {
      if (this.dialogType == 'hospital') {
        window.open('/医院指导价-批量导入.xlsx');
      } else {
        window.open('/批量导入产品资料.xlsx');
      }
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx' && arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file) {
      this.file = file;
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    sureLoad() {
      let self = this;
      self.percentage = 0;
      self.progressGuid = self.generateUUID();
      let timer = setInterval(self.getImportProgress, 1000);
      self.dialogVisible = true;
      let file = this.file;
      let formData = new FormData();
      let url = '';
      if (this.dialogType == 'hospital') {
        url =
          `/${serverConfig.msProductService}/import-data/goods-med-price-list?tenantGuid=` +
          localStorage.guid +
          '&progressGuid=' +
          self.progressGuid;
      } else {
        url =
          `/${serverConfig.msProductService}/import-data/goods?tenantGuid=` +
          localStorage.guid +
          '&progressGuid=' +
          self.progressGuid;
      }
      formData.append('file', file.raw); //传文件
      self.api.postFile(url, formData).then(function (res) {
        clearInterval(timer);
        self.dialogVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.active = 1;
          self.msg = res.data.data;
          self.getData(true);
          self.checkDownloadBtn(res.data.data);
        } else {
          self.$message({
            type: 'warning',
            message: res.data.msg,
          });
          return false;
        }
      });
    },
    getImportProgress() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminCloudService}/excel/import/get-import-progress?guid=` + self.progressGuid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.percentage = res.data.data ? res.data.data : 0;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    closeUpload() {
      this.dialogFormVisibleII = false;
      this.$refs.upload.clearFiles();
      this.active = 0;
    },
    checkDownloadBtn(msg) {
      if (msg.indexOf('失败 0 条') > -1) {
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
    },
    downLoadErrorExcel() {
      let self = this;
      let query = {
        tenantGuid: localStorage.guid,
      };
      let url = '';
      if (this.dialogType == 'hospital') {
        url = `/${serverConfig.msProductService}/goods/data/export-goods-med-price-error-report`;
      } else {
        url = `/${serverConfig.msProductService}/goods/data/export-goods-error-report`;
      }
      self.fullscreenLoading = true;
      self.api.postJson(url, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          self.fullscreenLoading = false;
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam, dataComments) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },
    // 导入产品结束

    /**
     * 获取商品大类字典
     */
    getPositionList() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=商品大类字典`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.goodsTreeData = res.data.data || [];
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
    },
    /**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>
